import { Routes } from '@angular/router';
import { UniversalLinkGuard } from './services/routeGuards.service';
import { BookingGuard } from './services/booking.guard';
import { appInitializedGuard } from './guards/app-initialized.guard';

export const routes: Routes = [
  // --- Routes hors guard (accessibles avant init) ---
  { path: '', redirectTo: 'splash', pathMatch: 'full' },
  {
    path: 'splash',
    loadComponent: () => import('../pages/splash/splash.page').then((m) => m.SplashPage),
    runGuardsAndResolvers: 'always',
    title: 'Chargement',
  },

  // --- Routes sous guard (nécessitent init terminée) ---
  {
    path: '',
    canMatch: [appInitializedGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('../pages/login/login.page').then((m) => m.LoginPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'login/:loginType',
        loadComponent: () => import('../pages/login/login.page').then((m) => m.LoginPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'dashboard',
        loadComponent: () => import('../pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
        runGuardsAndResolvers: 'always',
        title: 'Tableau de bord',
      },
      {
        path: 'accueil',
        loadComponent: () => import('../pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
        runGuardsAndResolvers: 'always',
        title: 'Accueil',
      },
      {
        path: 'code',
        loadComponent: () => import('../pages/code-home/code-home.page').then((m) => m.CodeHomePage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'conduite',
        loadComponent: () => import('../pages/conduite/conduite.page').then((m) => m.ConduiteHomePage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'examens-blancs',
        loadComponent: () =>
          import('../pages/driving-examens-blanc/driving-examens-blanc.page').then((m) => m.DrivingExamensBlancPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'examens-blancs/:examId',
        loadComponent: () =>
          import('../pages/driving-examen-blanc/driving-examen-blanc.page').then((m) => m.DrivingExamenBlancPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'report',
        loadComponent: () => import('../pages/report/report.page').then((m) => m.ReportPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'report/:lessonId',
        loadComponent: () => import('../pages/report/report.page').then((m) => m.ReportPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'convocation',
        loadComponent: () => import('../pages/convocation/convocation.page').then((m) => m.ConvocationPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'profil',
        loadComponent: () => import('../pages/profil/profil.page').then((m) => m.ProfilPage),
        runGuardsAndResolvers: 'always',
        canActivate: [UniversalLinkGuard],
        title: 'Profil',
      },
      {
        path: 'edit-profil',
        loadComponent: () => import('../pages/edit-profil/edit-profil.page').then((m) => m.EditProfilPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'edit-email',
        loadComponent: () => import('../pages/edit-email/edit-email.page').then((m) => m.EditEmailPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'edit-password',
        loadComponent: () => import('../pages/edit-password/edit-password.page').then((m) => m.EditPasswordPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'delete-account',
        loadComponent: () => import('../pages/delete-account/delete-account.page').then((m) => m.DeleteAccountPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'confettis',
        loadComponent: () => import('../pages/confettis/confettis.page').then((m) => m.ConfettisComponentPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'particles',
        loadComponent: () => import('../pages/particles/particles.page').then((m) => m.ParticlesComponentPage),
        runGuardsAndResolvers: 'always',
      },
      // series
      {
        path: 'series/:type',
        loadComponent: () => import('../pages/series/series.page').then((m) => m.SeriesPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'series/:type/:serieId/results/:sessionId',
        loadComponent: () => import('../pages/serie-results/serie-results.page').then((m) => m.SerieResultsPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'series/:type/:serieId/last-results/:sessionId',
        loadComponent: () => import('../pages/serie-results/serie-results.page').then((m) => m.SerieResultsPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'series/:type/:serieId/:questionIndex/:sessionId',
        loadComponent: () => import('../pages/serie/serie.page').then((m) => m.SeriePage),
        runGuardsAndResolvers: 'always',
      },
      // buffer
      {
        path: 'series/:type/:serieId/buffer',
        loadComponent: () => import('../pages/buffer/buffer.page').then((m) => m.BufferPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'series/:type/:serieId/buffer/:questionIndex/:sessionId',
        loadComponent: () => import('../pages/buffer/buffer.page').then((m) => m.BufferPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'series/:type/buffer',
        loadComponent: () => import('../pages/buffer/buffer.page').then((m) => m.BufferPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'serie-discovery',
        loadComponent: () => import('../pages/buffer/buffer.page').then((m) => m.BufferPage),
        runGuardsAndResolvers: 'always',
      },
      // statistiques
      {
        path: 'statistiques',
        loadComponent: () => import('../pages/statistiques/statistiques.page').then((m) => m.StatistiquesPage),
        runGuardsAndResolvers: 'always',
      },
      // cours
      {
        path: 'cours',
        loadComponent: () => import('../pages/cours/cours.page').then((m) => m.CoursPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'cours/:theme',
        loadComponent: () => import('../pages/cours/cours.page').then((m) => m.CoursPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'cours/:theme/:subtheme',
        loadComponent: () => import('../pages/cours/cours.page').then((m) => m.CoursPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'cours/:theme/:subtheme/:paragraph',
        loadComponent: () => import('../pages/cours/cours.page').then((m) => m.CoursPage),
        runGuardsAndResolvers: 'always',
      },
      // achats
      {
        path: 'achats',
        loadComponent: () => import('../pages/achats/achats.page').then((m) => m.AchatsPage),
        runGuardsAndResolvers: 'always',
      },
      // rating
      {
        path: 'rating',
        loadComponent: () => import('../pages/rating/rating.page').then((m) => m.RatingPage),
        runGuardsAndResolvers: 'always',
      },
      // offres
      {
        path: 'offres',
        loadComponent: () => import('../pages/offres/offres.page').then((m) => m.OffresPage),
        runGuardsAndResolvers: 'always',
      },
      // tunnel-paiement
      {
        path: 'tunnelpaiementv2',
        loadChildren: () =>
          import('../pages/tunnel-paiement-refonte/tunnel-paiement-refonte-routes').then(
            (feature) => feature.tunnelPaiementRefonteRoutes
          ),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'ma-route-vers-le-permis',
        loadComponent: () =>
          import('../pages/ma-route-vers-le-permis/ma-route-vers-le-permis.page').then((m) => m.RoadToPermisPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'reserver-lecon',
        loadComponent: () => import('../pages/reserver-lecon/reserver-lecon.page').then((m) => m.ReserverLeconPage),
        runGuardsAndResolvers: 'always',
        canActivate: [BookingGuard],
      },
      {
        path: 'reserver-lecon/:gearbox_type',
        loadComponent: () => import('../pages/reserver-lecon/reserver-lecon.page').then((m) => m.ReserverLeconPage),
        runGuardsAndResolvers: 'always',
        canActivate: [BookingGuard],
      },
      {
        path: 'points-de-rendez-vous',
        loadComponent: () => import('../pages/map-teacher/map-teacher.page').then((m) => m.MapTeacherPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'gmap',
        loadComponent: () => import('../pages/gmap/gmap.page').then((m) => m.GMapPage),
        runGuardsAndResolvers: 'always',
      },
      // leçons
      {
        path: 'lecons',
        loadComponent: () => import('../pages/lecons/lecons.page').then((m) => m.LeconsPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'lecons/:lessonId',
        loadComponent: () => import('../pages/lecons/lecons.page').then((m) => m.LeconsPage),
        runGuardsAndResolvers: 'always',
      },
      // première leçon
      {
        path: 'premiere-lecon',
        loadComponent: () => import('../pages/premiere-lecon/premiere-lecon.page').then((m) => m.PremiereLeconPage),
        runGuardsAndResolvers: 'always',
        canActivate: [BookingGuard],
      },
      // gamification
      {
        path: 'reussites',
        loadComponent: () => import('../pages/gamification/gamification.page').then((m) => m.GamificationPage),
        runGuardsAndResolvers: 'always',
      },
      // notation leçons
      {
        path: 'notation',
        loadComponent: () => import('../pages/notation/notation.page').then((m) => m.NotationPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'notation-enseignant',
        loadComponent: () =>
          import('../pages/notation-enseignant/notation-enseignant.page').then((m) => m.NotationEnseignantPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'impayes',
        loadComponent: () => import('../pages/impayes/impayes.page').then((m) => m.ImpayesPage),
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'paiement-confirmation',
        loadComponent: () =>
          import('../pages/paiement-confirmation/paiement-confirmation.page').then((m) => m.PaiementConfirmationPage),
        runGuardsAndResolvers: 'always',
      },
      // fiches-recap
      {
        path: 'fiches-recap',
        loadComponent: () => import('../pages/fiches-recap/fiches-recap.page').then((m) => m.FichesRecapPage),
        runGuardsAndResolvers: 'always',
      },
      // documents
      {
        path: 'documents',
        loadComponent: () =>
          import('../pages/student-documents/student-documents.page').then((m) => m.StudentDocumentsPage),
        runGuardsAndResolvers: 'always',
      },
      // terminer-mon-inscription
      {
        path: 'terminer-mon-inscription',
        loadComponent: () =>
          import('../pages/terminer-mon-inscription/terminer-mon-inscription.page').then(
            (m) => m.TerminerMonInscriptionPage
          ),
        runGuardsAndResolvers: 'always',
      },
      // mon-inscription-examen
      {
        path: 'mon-inscription-examen',
        loadComponent: () =>
          import('../pages/mon-inscription-examen/mon-inscription-examen.page').then((m) => m.MonInscriptionExamenPage),
        runGuardsAndResolvers: 'always',
      },
      // examens court terme
      {
        path: 'seconde-chance',
        loadComponent: () => import('../pages/short-term-exam/short-term-exam.page').then((m) => m.ShortTermExamPage),
        runGuardsAndResolvers: 'always',
        title: 'Ma Seconde Chance',
      },
      // reservation-examen
      {
        path: 'reservation-examen-code',
        loadComponent: () =>
          import('../pages/code-exam-reservation/code-exam-reservation.page').then((m) => m.CodeExamReservationPage),
        runGuardsAndResolvers: 'always',
      },
      // eligibilite-cpf
      {
        path: 'eligibilite-cpf/:secureId',
        loadComponent: () => import('../pages/eligibilite-cpf/eligibilite-cpf.page').then((m) => m.EligibiliteCPFPage),
        runGuardsAndResolvers: 'always',
      },
      // parrainage
      {
        path: 'parrainage',
        loadComponent: () => import('../pages/parrainage/parrainage.page').then((m) => m.ParrainagePage),
        runGuardsAndResolvers: 'always',
      },
      // test page
      {
        path: 'testpage',
        loadComponent: () => import('../pages/testpage/testpage.page').then((m) => m.TestPagePage),
        runGuardsAndResolvers: 'always',
      },
      // template page
      {
        path: 'template',
        loadComponent: () => import('../pages/template/template.page').then((m) => m.TemplatePage),
        runGuardsAndResolvers: 'always',
      },
      // sentry page
      {
        path: 'sentry',
        loadComponent: () => import('../pages/sentry/sentry.page').then((m) => m.SentryPage),
        runGuardsAndResolvers: 'always',
      },

      // ELSE 404
      {
        path: '**',
        loadComponent: () => import('../pages/notfound/notfound.page').then((m) => m.NotFoundPage),
        canActivate: [UniversalLinkGuard],
      },
    ],
  },
];
